import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const HiredApplicationsContainer = () => {
    const ApplStatus = "8";
    const Title = "Hired Applications";
    const Desc =  "Displays all applications that have successfully completed the recruitment process and resulted in employment. This module provides a centralized view of hired applicants, including employee information, assigned positions, hiring dates, and employment status for monitoring and reference purposes.";
    return (        
        <>
        <Breadcrumbs mainTitle="Hired" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default HiredApplicationsContainer;
